import { j as s } from "./atoms-v218.js";
import { forwardRef as l } from "react";
import { CheckList as m, Label as p, Inputs as h } from "./atoms-v2115.js";
const n = l(
  ({ ariaLabel: t, children: i, className: e, id: o, label: r = "", layout: a = "vertical" }, c) => /* @__PURE__ */ s.jsxs(m, { ref: c, children: [
    r ? /* @__PURE__ */ s.jsx(p, { children: r }) : null,
    /* @__PURE__ */ s.jsx(h, { $layout: a, "aria-label": t, className: e, id: o, children: i })
  ] })
);
n.displayName = "CheckList";
export {
  n as CheckList
};
